import React, { Component } from "react";

class UserSurvey extends Component {
  constructor(props) {
    super(props);
    props.getallUserSurvey();
  }
  state = {
    errorMessage: "",
    amount: 0,
    isRegister: true,
  };
  componentDidMount() {
    this.props.getallUserSurvey();
  }
  render() {
    const myLists = this.props.usersurveyJson;
    const listItems = myLists.map((myList) => (
      <li
        key={myList.id}
        className={
          myList.user_response !== true
            ? "Array-item"
            : "Array-item bg-light border border-success"
        }
      >
        <div className="title mb-2">
          <span className="text-danger">عنوان:</span>{" "}
          <span className="text-dark">{myList.survey_title}</span>
        </div>
        <div className="describe mb-2">
          <span className="text-danger font-weight-bold">تعداد سوالات:</span>{" "}
          <span className="text-dark multiple-line mb-0">
            {myList.survey_query_count}
          </span>
        </div>
        <div className="date">مهلت پاسخ: {myList.datetime_left}</div>
        {myList.user_response === true ? (
          <div className="describe rounded-pill text-left px-2 py-1 text-white mt-2">
            <span className="wp-text text-success font-weight-bold mt-2 text-justify">
              پاسخ داده شده در تاریخ {myList.datetime_join}
            </span>
          </div>
        ) : (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleSurvey(myList.id)}
              className="btn btn-warning btn-sm rounded-pill py-0 px-1 small-font"
            >
              شرکت در نظرسنجی
            </button>
          </div>
        )}
      </li>
    ));
    return (
      <div className="w-100 body-padding">
        <p className="wp-header">نظرسنجی های فعال</p>
        <ul className="Array p-0 mb-5">
          {listItems.length === 0 ? (
            <li className="Array-item">
              <div className="title">
                نظرسنجی فعالی برای شما تعریف نشده است.
              </div>
            </li>
          ) : (
            listItems
          )}
        </ul>
      </div>
    );
  }
  handleSurvey = (e) => {
    this.props.participateSurvey(e);
  };
}
export default UserSurvey;
